export const MuiFormControlLabel = palette => ({
  styleOverrides: {
    label: {
      '&.Mui-disabled': {
        color: palette.button.text.disabled
      }
    }
  }
})
